import http from "infra/http";
import { useMutation } from "react-query";

function useTogglePostagemStatus() {
  return useMutation(
    "/v1/mural/mudar-status",
    async (params: { id: string; nextStatus: boolean }) =>
      http.put(
        `/v1/mural/${params.id}/${params.nextStatus ? "ativar" : "desativar"}`
      )
  );
}

export default useTogglePostagemStatus;
